import {
  Component,
  ElementRef,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { _ButtonBase } from './button-base.component';
import { BUTTON_HOST_ATTRIBUTES, BUTTON_SIZES, ButtonSize } from './button.types';
import { ButtonIconSizeMap } from '../shared/theme.types';
import { IconComponent } from '../icon/icon.component';

/**
 * @class
 * @description
 * ButtonIconComponent is currently under development.
 * Use with caution as it may exhibit unexpected behaviors.
 *
 * @see examples on [README](./README.md)
 *
 * Inspired by material's button
 * @see https://material.angular.io/components/button/api
 */
@Component({
    selector: `yoo-button-icon`,
    imports: [
        CommonModule,
        IconComponent,
    ],
    templateUrl: './button-icon.component.html'
})
export class ButtonIconComponent extends _ButtonBase {

  @Input() icon!: string;

  sizes = BUTTON_SIZES;
  sizeMap = ButtonIconSizeMap;
  iconSize!: number;

  constructor(elementRef: ElementRef) {
    super(elementRef);

    for (const attr of BUTTON_HOST_ATTRIBUTES) {
      if (this.hasHostAttributes(attr)) {
        this.getHostElement().classList.add(`button-${attr}`);

        if (this.sizes.includes(attr as ButtonSize)) {
          this.iconSize = this.sizeMap[attr as ButtonSize] as number;
        } else {
          this.getHostElement().classList.add('button-small');
          this.iconSize = this.sizeMap['small'];
        }
      }
    }

    elementRef.nativeElement.classList.add('button-icon');
  }

  private getHostElement(): HTMLElement {
    return this._elementRef.nativeElement;
  }

  /** Gets whether the button has one of the given attributes. */
  private hasHostAttributes(...attributes: string[]): boolean {
    return attributes.some((attribute) =>
      this.getHostElement().hasAttribute(attribute),
    );
  }
}
